module.exports = __webpack_public_path__ + "img/tool2.633c9eb6.png";